import {ActionPropsHolder} from './actionProps';
import {close, onClose} from './close';
import {onShowDeleted, showDeleted} from './showDeleted';

export function closeOrShowDeleted(
  holder: ActionPropsHolder,
  onClose?: onClose,
  onShowDeleted?: onShowDeleted,
) {
  console.log('closeOrShowDeleted1');

  if (onClose) {
    console.log('closeOrShowDeleted2');
    return close(holder, onClose);
  }
  console.log('closeOrShowDeleted3');

  return showDeleted(holder, onShowDeleted);
}
